import { render } from "./SingleCandle.vue?vue&type=template&id=a4d5e9f0&scoped=true&lang=html"
import script from "./SingleCandle.vue?vue&type=script&lang=js"
export * from "./SingleCandle.vue?vue&type=script&lang=js"

import "./SingleCandle.vue?vue&type=style&index=0&id=a4d5e9f0&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4d5e9f0"]])

export default __exports__